import { BLOCK_TYPES } from '../utils/constants';
import { DayBlockDTO, IDayBlockDTO } from './day-block';
import { FileUpload } from '@models/file';

export interface IWYSIWYGBlock extends IDayBlockDTO {
  html: string;
  voiceId: string;
}
export class WYSIWYGBlock extends DayBlockDTO implements IWYSIWYGBlock {
  blockType: BLOCK_TYPES = BLOCK_TYPES.WYSIWYGBlock;
  html: string = '';
  voiceId: string = '';
  originalTranscription?: string = null;
  file: FileUpload;
}
